import {SousMenuItemAggregate} from './sous-menu-item.aggregate';
import {AutorisationsAggregate} from '../autorisation/autorisations.aggregate';
import {MenuItemModel} from '../../models/menu/menu-item.model';
import {LienItemModel} from '../../models/menu/lien-item.model';
import {forkJoin, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ContextDroitsModel} from '../../models/menu/context-droits.model';

export class MenuItemAggregate {
  constructor(
    readonly iconClass: string,
    readonly libelle: string,
    readonly sousMenusItems?: Array<SousMenuItemAggregate>,
    readonly routerLink?: string,
    readonly autorisations?: AutorisationsAggregate,
  ) {}

  getMenuItemWithVisibilityFromContext(
    context: ContextDroitsModel,
  ): Observable<{menuItem: MenuItemAggregate; isVisible: boolean}> {
    if (!this.autorisations) {
      return of({
        menuItem: this,
        isVisible: true,
      });
    }
    return this.autorisations.isAuthorizedForContext(context).pipe(
      map(isVisible => {
        return {
          menuItem: this,
          isVisible: isVisible,
        };
      }),
    );
  }

  buildMenuItemFromContext(context: ContextDroitsModel): Observable<MenuItemModel> {
    return this.getSousMenusItemFromContext(context).pipe(
      map(o => {
        return Object.assign(new MenuItemModel(), {
          iconClass: this.iconClass,
          libelle: this.libelle,
          routerLink: this.routerLink,
          sousMenu: o,
        });
      }),
    );
  }

  getSousMenusItemFromContext(context: ContextDroitsModel): Observable<Array<LienItemModel>> {
    if (this.sousMenusItems) {      
      return forkJoin(this.sousMenusItems.map(o => o.getSousMenuItemWithVisibilityFromContext(context))).pipe(
        map(o => o.filter(x => x.isVisible)),
        map(o => o.map(x => x.sousMenu.buildSousMenuItem())),
      );
    }

    return of([]);
  }
}
